var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "card-header py-2 px-3 d-flex align-items-center",
      class: _vm.customClass,
    },
    [
      _c(
        "h5",
        { staticClass: "m-0 font-weight-bold text-primary fs-20 fw-700" },
        [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]
      ),
      _vm._v(" "),
      _vm._t("actions"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }